import { render, staticRenderFns } from "./LwaCallback.vue?vue&type=template&id=49b90dd1&"
import script from "./LwaCallback.vue?vue&type=script&lang=js&"
export * from "./LwaCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports